<template>
  <div class="about-web">
    <div style="background: rgba(249, 249, 249, 1)" id="Overview">
      <div
        class="box family1"
        style="display: flex; justify-content: space-around; padding: 0.86rem 0"
      >
        <div style="width: 5.5rem; text-align: left">
          <p class="size35 family1" style="margin: 0.1rem 0">
            {{ $t("AboutUs.title") }}
          </p>
          <p class="size14">
            {{ $t("AboutUs.des1") }}
            {{ $t("AboutUs.des11") }}
            <span class="family3">{{ $t("AboutUs.des12") }}</span>
            {{ $t("AboutUs.des13") }}
          </p>
          <p class="size14" style="margin: 0.15rem 0">
            {{ $t("AboutUs.des2") }}
          </p>
          <a
            href="https://www.redteamobile.com/红茶移动企业简介-中文_20200827.pdf"
            target="blank"
            style="color: rgba(211, 36, 23, 1)"
            v-show="!langShow"
          >
            <div style="display: flex; align-items: center">
              <img
                src="../assets/about-web/下载.svg"
                style="width: 0.3rem; margin-right: 0.1rem"
              />
              <span class="size14" style="cursor: pointer">{{
                $t("AboutUs.download")
              }}</span>
            </div>
          </a>

          <a
            href="https://www.redteamobile.com/Redtea Mobile Company Profile_20200827.pdf"
            target="blank"
            style="color: rgba(211, 36, 23, 1)"
            v-show="langShow"
          >
            <div style="display: flex; align-items: center">
              <img
                src="../assets/about-web/下载.svg"
                style="width: 0.3rem; margin-right: 0.1rem"
              />
              <span class="size14" style="cursor: pointer">{{
                $t("AboutUs.download")
              }}</span>
            </div>
          </a>
        </div>
        <div>
          <img src="../assets/about-web/头图.png" style="width: 5.9rem" />
        </div>
      </div>
    </div>

    <div
      style="
        background: rgba(117, 130, 154, 1);
        color: rgba(255, 255, 255, 0.8);
        padding-top: 0.8rem;
      "
    >
      <p class="size35 family1">{{ $t("AboutUs.title0") }}</p>
      <div
        class="box our"
        style="
          display: flex;
          justify-content: space-between;
          padding: 0.4rem 0 1.2rem 0;
          text-align: left;
        "
      >
        <div style="width: 5.5rem">
          <p
            class="size20 family2 before-img1"
            style="margin-bottom: 0.2rem; position: relative"
            id="Mission"
          >
            {{ $t("AboutUs.mission.title") }}
          </p>
          <p class="size14">{{ $t("AboutUs.mission.des1") }}</p>
          <p class="size14" style="margin-bottom: 0.3rem">
            - {{ $t("AboutUs.mission.des2") }}
          </p>
          <p
            class="size20 family2 before-img2"
            style="margin-bottom: 0.2rem; position: relative"
            id="Vision"
          >
            {{ $t("AboutUs.vision.title") }}
          </p>
          <p class="size14">{{ $t("AboutUs.vision.des1") }}</p>
          <p class="size14">- {{ $t("AboutUs.vision.des2") }}</p>
        </div>
        <div style="width: 5.5rem">
          <p
            class="size20 family2 before-img3"
            style="margin-bottom: 0.2rem; position: relative"
            id="Values"
          >
            {{ $t("AboutUs.values.title") }}
          </p>
          <p class="size14">{{ $t("AboutUs.values.des") }}</p>
          <p class="size14" style="margin: 5px 0">
            -{{ $t("AboutUs.values.title1") }}
          </p>
          <ul style="margin-left: 25px">
            <li class="size14">{{ $t("AboutUs.values.text1") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text2") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text3") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text4") }}</li>
          </ul>
          <p class="size14" style="margin: 5px 0">
            -{{ $t("AboutUs.values.title2") }}
          </p>
          <ul style="margin-left: 25px">
            <li class="size14">{{ $t("AboutUs.values.text5") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text6") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text7") }}</li>
            <li class="size14">{{ $t("AboutUs.values.text8") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      style="background: rgba(249, 249, 249, 1); padding: 1.2rem 0"
      id="Recognition"
    >
      <div class="box recognition" style="width: 10.32rem">
        <p class="size35 family1" style="margin-bottom: 0.28rem">
          {{ $t("AboutUs.recog.title") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          {{ $t("AboutUs.recog.des") }}
        </p>
        <div>
          <div class="radius-box1 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content1") }}
            </div>
          </div>
          <div class="radius-box2 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content2") }}
            </div>
          </div>
          <div class="radius-box3 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content3") }}
            </div>
          </div>
          <div class="radius-box4 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content4") }}
            </div>
          </div>
          <div class="radius-box5 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content5") }}
            </div>
          </div>
          <div class="radius-box7 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content7") }}
            </div>
          </div>
          <div class="radius-box8 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content8") }}
            </div>
          </div>
          <div class="radius-box9 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content9") }}
            </div>
          </div>
          <div class="radius-box3 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content11") }}
            </div>
          </div>
          <div class="radius-box4 float-box">
            <div class="radius-box size12">
              {{ $t("AboutUs.recog.content12") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="background: rgba(249, 249, 249, 1); padding: 300px 0 1.2rem 0"
      id="Careers"
    >
      <div class="box partner" style="width: 10.32rem; margin: auto">
        <p class="size35 family1" style="margin-bottom: 0.2rem">
          {{ $t("AboutUs.partner.title") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          {{ $t("AboutUs.partner.des") }}
          <span style="color: rgb(211, 36, 23)">{{
            $t("AboutUs.partner.des1")
          }}</span>
        </p>
        <p class="size14 family1" style="text-align: left"></p>
      </div>
    </div>

    <div class="box diff" style="padding: 0.75rem 0" id="Team">
      <div style="width: 10.32rem; margin: auto">
        <p class="size35 family1" style="margin-bottom: 0.2rem">
          {{ $t("AboutUs.diff.title") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          {{ $t("AboutUs.diff.des1") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          {{ $t("AboutUs.diff.des2") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          - {{ $t("AboutUs.diff.text1") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          - {{ $t("AboutUs.diff.text2") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          - {{ $t("AboutUs.diff.text3") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          - {{ $t("AboutUs.diff.text4") }}
        </p>
        <p class="size14 family1" style="text-align: left; margin-top: 0.2rem">
          {{ $t("AboutUs.diff.text5") }}
        </p>
        <p class="size14 family1" style="text-align: left">
          {{ $t("AboutUs.diff.text6") }}
          <span style="color: rgb(211, 36, 23)">{{
            $t("AboutUs.diff.text7")
          }}</span>
        </p>
        <div
          style="
            margin-top: 0.4rem;
            text-align: left;
            font-family: 'Poppins-Light';
            font-size: 14px;
          "
        >
          <p class="job-title">{{ $t("AboutUs.diff.job1") }}</p>
          <ul style="margin-left: 40px">
            <li>{{ $t("AboutUs.diff.jobDes1") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes2") }}</li>
          </ul>
          <p class="job-title">{{ $t("AboutUs.diff.job2") }}</p>
          <ul style="margin-left: 40px">
            <li>{{ $t("AboutUs.diff.jobDes3") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes4") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes5") }}</li>
          </ul>
          <p class="job-title">{{ $t("AboutUs.diff.job3") }}</p>
          <ul style="margin-left: 40px">
            <li>{{ $t("AboutUs.diff.jobDes6") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes7") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes8") }}</li>
          </ul>
          <p class="job-title">{{ $t("AboutUs.diff.job4") }}</p>
          <ul style="margin-left: 40px">
            <li>{{ $t("AboutUs.diff.jobDes9") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes10") }}</li>
            <li>{{ $t("AboutUs.diff.jobDes11") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="box gallery">
      <p class="size35 family1" style="margin-bottom: 0.3rem">
        {{ $t("AboutUs.gallery") }}
      </p>
      <Carousel
        v-model="value3"
        :autoplay="true"
        :radius-dot="true"
        trigger="hover"
        arrow="always"
        :autoplay-speed="4000"
        loop
      >
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/_DSC1076.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/1.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/2.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/3.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/4.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/5.png" />
          </div>
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "about-web",
  components: {},
  data() {
    return {
      value3: 0,
    };
  },
  computed: {
    langShow: function () {
      return this.$store.state.localLang === "en" ? true : false;
    },
  },
};
</script>
<style lang="less" scoped>
.about-web {
  color: rgba(32, 49, 82, 1);
  .box {
    width: 11.8rem;
    margin: auto;
  }
  .family1 {
    font-family: "Poppins-Light";
  }
  .family2 {
    font-family: "Poppins-Regular";
  }
  .family3 {
    font-family: "Poppins-Bold";
  }
  .size35 {
    font-size: 0.35rem;
  }
  .size14 {
    font-size: 14px;
  }
  .size12 {
    font-size: 12px;
  }
  .size20 {
    font-size: 20px;
  }
  .float-box {
    float: left;
    margin: 0.2rem 0.1rem 0 0;
    width: 2.4rem;
    height: 95px;
    box-sizing: border-box;
    padding: 3px;
    border-radius: 10px;
  }
  .radius-box {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(249, 249, 249);
  }
  .radius-box1 {
    background-image: linear-gradient(
      to right,
      rgba(255, 0, 0, 0.4),
      rgba(6, 91, 255, 0.4)
    );
  }
  .radius-box2 {
    background-image: linear-gradient(
      to right,
      rgba(187, 183, 25, 0.4),
      rgba(0, 188, 168, 0.4)
    );
  }
  .radius-box3 {
    background-image: linear-gradient(
      to right,
      rgba(0, 132, 255, 0.4),
      rgba(27, 12, 96, 0.4)
    );
  }
  .radius-box4 {
    background-image: linear-gradient(
      to right,
      rgba(118, 104, 104, 0.4),
      rgba(58, 12, 98, 0.4)
    );
  }
  .radius-box5 {
    background-image: linear-gradient(
      to right,
      rgba(5, 69, 52, 0.4),
      rgba(239, 88, 0, 0.4)
    );
  }
  .radius-box6 {
    background-image: linear-gradient(
      to right,
      rgba(48, 24, 83, 0.4),
      rgba(139, 67, 20, 0.4)
    );
  }
  .radius-box7 {
    background-image: linear-gradient(
      to right,
      rgba(16, 79, 29, 0.4),
      rgba(20, 55, 123, 0.4)
    );
  }
  .radius-box8 {
    background-image: linear-gradient(
      to right,
      rgba(13, 64, 107, 0.4),
      rgba(255, 147, 34, 0.4)
    );
  }
  .radius-box9 {
    background-image: linear-gradient(
      to right,
      rgba(255, 0, 0, 0.4),
      rgba(6, 91, 255, 0.4)
    );
  }
  .ra-box {
    width: 2.65rem;
    height: 0.8rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.05);
    padding-top: 0.15rem;
  }
  .gallery {
    padding-bottom: 1.2rem;
  }
  .job-title {
    font-family: "Poppins-Regular";
    font-size: 14px;
    margin: 0.5rem 0 0.2rem 0;
  }
  .before-img1:before {
    background-image: url("../assets/about-web/1@2x.svg");
    content: "";
    background-size: 25px 25px;
    position: absolute;
    width: 25px;
    height: 25px;
    left: -30px;
    top: 2px;
  }
  .before-img2:before {
    background-image: url("../assets/about-web/2@2x.svg");
    content: "";
    background-size: 25px 25px;
    position: absolute;
    width: 25px;
    height: 25px;
    left: -30px;
    top: 2px;
  }
  .before-img3:before {
    background-image: url("../assets/about-web/3@2x.svg");
    content: "";
    background-size: 25px 25px;
    position: absolute;
    width: 25px;
    height: 25px;
    left: -30px;
    top: 2px;
  }
}
</style>